<template>
	<div id="sidebar">
		<div class="top-bar">
			<h1 class="brand">ITFA</h1>
		</div>
		<b-nav class="w-100 sidebar__nav mt-3">
			<!-- Home -->
			<b-nav-item-dropdown noCaret>
				<template slot="button-content">
					<i class="flaticon-home"></i>
					<span>{{ $t('home') }}</span>
				</template>
				<b-dropdown-item :to="{ name: 'Home', params: { lang: lang } }">
					<i class="flaticon-home"></i>
					<span>{{ $t('home') }}</span>
				</b-dropdown-item>
				<b-dropdown-item :to="{ name: 'AboutUs', params: { lang: lang } }">
					<i class="flaticon-hombre-de-negocios"></i>
					<span>{{ $t('aboutUs') }}</span>
				</b-dropdown-item>
				<b-dropdown-item href="https://m.me/ITFA.GLOBAL.N" target="_BLANK">
					<i class="flaticon-mail"></i>
					<span>{{ $t('contact') }}</span>
				</b-dropdown-item>
				<b-dropdown-item v-if="isAuthenticated" @click="logout">
					<i class="flaticon-logout"></i>
					<span>{{ $t('logout') }}</span>
				</b-dropdown-item>
			</b-nav-item-dropdown>
			<!-- Torneos -->
			<b-nav-item-dropdown noCaret v-if="isAuthenticated">
				<template slot="button-content">
					<i class="flaticon-cup"></i>
					<span>{{ $t('tournaments') }}</span>
				</template>
				<b-dropdown-item
					:to="{
						name: 'UsersBackFavouriteTournaments',
						params: { lang: lang, console: console },
					}"
				>
					<i class="flaticon-trophy"></i>
					<span>{{ $t('favorites') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{
						name: 'Tournaments',
						params: { lang: lang, console: console },
					}"
				>
					<i class="flaticon-reward"></i>
					<span>{{ $t('tournaments') }}</span>
				</b-dropdown-item>
			</b-nav-item-dropdown>
			<!-- Usuario -->
			<b-nav-item-dropdown noCaret v-if="isAuthenticated">
				<template slot="button-content">
					<i class="flaticon-user-male-black-shape"></i>
					<span>{{ $t('profile') }}</span>
				</template>
				<b-dropdown-item
					:to="{
						name: 'PlayerHome',
						params: { lang: lang, console: console, playerSlug: user.slug },
					}"
				>
					<i class="flaticon-male"></i>
					<span>{{ $t('myProfile') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{
						name: 'UsersBackFavouriteFriends',
						params: { lang: lang, console: console },
					}"
				>
					<i class="flaticon-user"></i>
					<span>{{ $t('friends') }}</span>
				</b-dropdown-item>
				<b-dropdown-item :to="{ name: 'EditUser', params: { lang: lang } }">
					<i class="flaticon-user-profile-edition"></i>
					<span>{{ $t('edit') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'ChangePassword', params: { lang: lang } }"
				>
					<i class="flaticon-contrasena"></i>
					<span>{{ $t('password') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'NoticeUserList', params: { lang: lang } }"
				>
					<i class="flaticon-noticias"></i>
					<span>{{ $t('myNews') }}</span>
				</b-dropdown-item>
			</b-nav-item-dropdown>
			<!-- Equipos -->
			<b-nav-item-dropdown noCaret v-if="isAuthenticated">
				<template slot="button-content">
					<i class="flaticon-shield-symbol"></i>
					<span>{{ $t('teams') }}</span>
					<!-- <span>{{$t('myClub')}}</span> -->
				</template>
				<b-dropdown-item
					:to="{
						name: 'UsersBackFavouriteTeams',
						params: { lang: lang, console: console },
					}"
				>
					<i class="flaticon-shield-with-two-leaves-branches"></i>
					<span>{{ $t('favorites') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'TeamsBack', params: { lang: lang, console: console } }"
				>
					<i class="flaticon-arsenal"></i>
					<span>{{ $t('myTeams') }}</span>
				</b-dropdown-item>
			</b-nav-item-dropdown>
			<!-- Notificaciones -->
			<b-nav-item-dropdown noCaret v-if="isAuthenticated">
				<template slot="button-content">
					<i class="flaticon-turn-notifications-on-button"></i>
					<span>{{ $tc('notification', 2) | toCapitalize }}</span>
				</template>
				<b-dropdown-item
					:to="{
						name: 'UsersBackNotifications',
						params: { lang: lang, console: console },
					}"
				>
					<i class="flaticon-notification"></i>
					<span>{{ $tc('notification', 2) | toCapitalize }}</span>
					<div v-if="user.notifications > 0" class="bagde">
						{{ user.notifications }}
					</div>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{
						name: 'UsersBackInvitations',
						params: { lang: lang, console: console },
					}"
				>
					<i class="flaticon-mail"></i>
					<span>{{ $tc('invitation', 2) | toCapitalize }}</span>
					<div v-if="user.invitations > 0" class="bagde">
						{{ user.invitations }}
					</div>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{
						name: 'UsersBackMessages',
						params: { lang: lang, console: console },
					}"
				>
					<i class="flaticon-mail"></i>
					<span>{{ $t('messages') }}</span>
				</b-dropdown-item>
			</b-nav-item-dropdown>
			<b-nav-item
				v-if="!isAuthenticated"
				:to="{ name: 'Login', params: { lang } }"
			>
				<i class="flaticon-enter"></i>
				<span>{{ $t('login') }}</span>
			</b-nav-item>
			<b-nav-item
				v-if="!isAuthenticated"
				:to="{ name: 'Register', params: { lang: lang } }"
			>
				<i class="flaticon-clipboard-with-pencil"></i>
				<span>{{ $t('check_in') }}</span>
			</b-nav-item>
			<b-nav-item @click="openModalSearch()">
				<i class="flaticon-search"></i>
				<span>{{ $t('search') }}</span>
			</b-nav-item>
			<!-- Opciones del administrador -->
			<b-nav-item-dropdown noCaret v-if="isAuthenticated">
				<template slot="button-content">
					<i class="flaticon-equipo"></i>
					<span>{{ $t('options') }}</span>
				</template>
				<b-dropdown-item
					:to="{ name: 'EditUserInfoAdmin', params: { lang: lang } }"
					v-if="user.isAdmin"
				>
					<i class="flaticon-usuario"></i>
					<span>{{ $t('editInfoUser') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'Administrator', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-anadir"></i>
					<span>{{ $t('createAdmins') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'Slider', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-foto"></i>
					<span>{{ $t('sliderPrimary') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'SuperChangePassword', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-contrasena-1"></i>
					<span>{{ $t('password') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'AdminCountries', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<img
						src="../../assets/images/pin.png"
						alt="Paises"
						class="img-fluid"
					/>
					<span>{{ $t('countries') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'SuperChangeNick', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-ajustes"></i>
					<span>{{ $t('changeGt') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'SuperChangeToPremium', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-prima"></i>
					<span>{{ $t('toPremium') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'SuperUpdateData', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-refrescar"></i>
					<span>{{ $t('updatedData') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'SuperTutorials', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-cine"></i>
					<span>{{ $t('tutorialCreate') }}</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{
						name: 'Bets',
						params: { lang: lang, console: console },
						query: { page: 1 },
					}"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-futbol"></i>
					<span>{{ $t('bets') }} VS</span>
				</b-dropdown-item>
				<b-dropdown-item
					:to="{ name: 'ClearImages', params: { lang: lang } }"
					v-if="user.type === 'SUPER'"
				>
					<i class="flaticon-anadir"></i>
					<span>Borrar imágenes</span>
				</b-dropdown-item>
			</b-nav-item-dropdown>
		</b-nav>
		<modal-search />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalSearch from './ModalSearch'

export default {
	components: {
		ModalSearch,
	},
	computed: {
		...mapGetters(['lang', 'isAuthenticated', 'user', 'console']),
	},
	mounted() {
		if (this.$auth.isAuthenticated()) {
			let lang = localStorage.getItem('lang')
			if (!lang) {
				lang = 'en'
			}
			const console = this.$route.params.console
			const path = `auth/${lang}/${console}/user/data`
			this.$axios.get(path).then((response) => {
				const data = response.data.data
				this.$store.dispatch('SET_MY_TUTORIALS', data.tutorials)
				delete data.tutorials
				this.$store.dispatch('SET_USER', data)
			})
		}
	},
	methods: {
		openModalSearch() {
			this.$root.$emit('bv::show::modal', 'modalSearch')
		},
		hideShowSideBar() {
			window.toastr.success('demo')
		},
		logout() {
			const path = `auth/${this.lang}/logout`
			this.$axios.post(path).then(() => {
				this.$auth.destroyToken()
				this.$store.dispatch('SET_AUTHENTICATED', false)
				this.$store.dispatch('SET_TOURNAMENTS', [])
				this.$store.dispatch('SET_USER', {})
				this.$router.push({ name: 'Login', params: { lang: this.lang } })
				location.reload()
			})
		},
	},
}
</script>
